import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { EMPTY, Observable } from 'rxjs';
import { Injectable } from '@angular/core';

/**
 * An HTTP interceptor that prevents the requests from being sent when
 * the document is not in the foreground. An example of this is a stuation
 * when the angular app runs in the browser tab that is inactive (is in the background).
 */
@Injectable()
export class DocumentVisibilityInterceptor implements HttpInterceptor {
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // Instant Payment must finish initialization and redirect callbacks while hidden.
    const isInstantPayment =
      window.location.pathname.includes('/instant-payment');
    if (document.hidden && !isInstantPayment) {
      return EMPTY;
    }

    return next.handle(request);
  }
}
